<template>
  <div class="sidearm-mm-accordion border-light-b" :class="{ active: is_open }">
    <button
      @click="toggle_accordion(!is_open)"
      role="button"
      class="sidearm-mm-accordion__button flex flex-justify-between flex-align-center"
    >
      <span class="text-bold">
        <slot name="button" />
      </span>
      <span
        >{{ is_open ? "Show Less" : "Expand"
        }}<icon>{{
          is_open ? "sf-minus-minimal" : "sf-plus-minimal"
        }}</icon></span
      >
    </button>
    <transition
      name="accordion"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
    >
      <div
        v-show="is_open"
        class="sidearm-mm-accordion__body bg-white text-black"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data: () => ({
    is_open: false
  }),
  methods: {
    toggle_accordion(value) {
      if (value !== undefined) {
        this.is_open = !!value;
      } else {
        this.is_open = !this.is_open;
      }
      //600ms because the accordion transition is 500ms
      setTimeout(() => {
        this.reBuild();

        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      }, 600);
    },
    beforeEnter: function(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave: function(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    }
  }
};
</script>
<style lang="scss" scoped>
.sidearm-mm-accordion {
  &__button {
    @include base-reset();
    width: 100%;
    background: $color-white;
    color: $color-black;
    padding: $spacer * 3 $spacer * 2;
  }
  &__body {
    overflow: hidden;
    transition: 0.5s;
  }

  &.active {
    .sidearm-mm-accordion {
      &__button {
        background: $color-primary;
        color: $text-on-primary;
      }
    }
  }
}
</style>
